export class AvailabilityPostModel {
    UserHoursOfOperations: UserHoursOfOperations[] = [];
}



export class UserHoursOfOperations {
    userHoursOfOperationId: number = 0;
    userId: number = 0;
    weekNumber: number = 0;
    dayNumber: number = 0;
    startTime: any;
    endTime: any;
    workLocationId: number | null = null;
    isAvailable: boolean = false;
    eligibleForInPersonAppointments: boolean = false;
    eligibleForPhoneAppointments: boolean = false;
    eligibleForVirtualAppointments: boolean = false;


}